<!-- Title  -->
<div class="splash-title w-full flex flex-col justify-center items-center pt-12 pb-8 px-4">
	<div class="sparkle-title" aria-hidden="true">
		<sparkle-twinkle class="sparkle-title__sparkle sparkle-title__sparkle--left-top"></sparkle-twinkle>
		<sparkle-twinkle class="sparkle-title__sparkle sparkle-title__sparkle--right-top" sparkleVariant="2"></sparkle-twinkle>
        <sparkle-twinkle class="sparkle-title__sparkle sparkle-title__sparkle--left-bottom"></sparkle-twinkle>
		<sparkle-twinkle class="sparkle-title__sparkle sparkle-title__sparkle--right-bottom" sparkleVariant="2"></sparkle-twinkle>
	</div>

    <!-- CRUST Logo -->
    <div class="mb-4 px-10 w-full flex justify-center">
        <crust-logo [color]="'#FFFFFF'" [size]="'w-full max-w-[200px] h-auto'"></crust-logo>
    </div>

    <!-- Title image -->
    <div class="justify-center m-4">
        <img src="assets\images\ui\title-crust-of-life.png" alt="Crust of Life" class="w-full h-auto" />
    </div>

    <!-- Headline -->
    <div class="w-full flex flex-col items-center gap-4 px-12 my-6">
        <img src="assets\images\ui\splash-headline.png" alt="Celebrating 25 Years" class="mb-4" />

        <!-- Play Button -->
        <div class="text-center p-4">
			<button routerLink="/auth/login" class="red-cta-btn-xlg retro-pixel-regular">
                PLAY&#x2002;NOW&#x2002;&&#x2002;WIN
            </button>
        </div>
    </div>

</div>

<!-- Character  -->
<div class="mt-2">

    <!-- Speech -->
    <div class="speech-bubble-overlay">
        <div class="speech-bubble-container speech-bob-animation">
            <img src="assets\images\ui\splash-speech-right-blank.png" alt="Play Crust of Life" />
            <p class="speech-bubble-text">
                Play Crust of Life. Make your choices, live the chaos, and win daily prizes!
            </p>
        </div>
    </div>

    <!-- Overlaid Crustopher -->
    <div class="crustopher-overlay">
        <img [src]="avatarImage()" alt="Crustopher Avatar" class="crustopher-image" (click)="onAvatarClick()">
    </div>

</div>

<!-- Prizes with Responsive Overlay -->
<div class="full-bleed bg-base-content">
    <div class="w-full max-w-[480px] mx-auto">
        <div class="
            md:mt-[170px] mt-[0px] 
            md:pt-[70px] pt-[80px] 
            relative w-full flex justify-center items-center px-4 z-10">
            <!-- Container that controls the responsive scaling -->
            <div class="relative w-full px-4 pb-8">

                <!-- Background image - will overflow viewport -->
                <div class="absolute inset-0 flex justify-center items-center prize-bg-animation z-10"
                    style="left: 50%; width: 130%;">
                    <img src="assets\images\ui\splash-prize-bg.png" alt="Background" class="w-full h-auto" />
                </div>

                <!-- Foreground/Title image - stays within bounds -->
				<div class="relative z-10">
					<img src="assets\images\ui\splash-prize-fg-nocta.png" alt="Crust of Life" class="w-full h-auto" />
					<div class="absolute inset-x-0 sm:bottom-[20px] bottom-[15px] flex justify-center">
						<button routerLink="/auth/login" class="red-cta-btn-xlg retro-pixel-regular">
							PLAY&#x2002;NOW&#x2002;&&#x2002;WIN
						</button>
					</div>
                </div>

            </div>
        </div>
    </div>
</div>

<!--Content - Turning 25 -->
<div class="full-bleed bg-base-content py-14 px-4 md:px-0">
    <div class="flex flex-col items-center justify-center w-full max-w-[480px] mx-auto px-4">
        <h3 class="text-center text-white">
            CRUST IS TURNING 25, <br class="desktop-break">AND LIFE'S A BIT OF A MESS <br class="desktop-break">(IN THE BEST WAY).
        </h3>
        <div class="horizontal-rule bg-white my-8"></div>
        <p class="text-center my-4 text-white">
            Step into Crust of Life — the game where your choices shape your story.
        </p>
        <p class="text-center my-4 text-white">
            From pizza-fuelled nights to big life moves, every decision earns you happiness points and daily rewards.
        </p>
        <p class="text-center my-4 text-white">
            View Terms & Conditions
        </p>
    </div>
</div>

<!--Content - What is... -->
<div class="full-bleed bg-neutral py-14 px-4 md:px-0">
    <div class="flex flex-col items-center justify-center w-full max-w-[480px] mx-auto px-4">
        <h3 class="text-center">
            WHAT IS CRUST OF LIFE?
        </h3>
        <div class="horizontal-rule bg-base-content my-8"></div>
        <p class="text-center my-4">
            We’re celebrating 25 years of Crust with a game that’s all about life’s little slices — the good, the weird, and the
            extra cheesy.
        </p>
        <p class="text-center my-4">
            Each day, make a choice that shapes your Crust of Life journey. Stack up happiness points, unlock instant prizes,
            and see how your life path compares to other players.
        </p>
        <p class="text-center my-4">
            Will you climb the career ladder or chase a chill life full of pizza and friends?
        </p>
        <p class="text-center my-4">
            One choice a day shapes your fate — and your rewards.
        </p>
        <h3 class="text-center my-4 py-8">
            COMPARE YOUR CRUST OF LIFE WITH FRIENDS AND SHARE WHERE YOUR STORY ENDS UP.
        </h3>
        <!-- Play Button -->
		<div class="text-center p-4 ">
			<button routerLink="/auth/login" class="red-cta-btn-xlg retro-pixel-regular">
				PLAY&#x2002;NOW&#x2002;&&#x2002;WIN
			</button>
		</div>
		<!-- Overlaid Crustopher -->
		<div class="crustopher-overlay crustopher-overlay--prize">
			<img [src]="avatarImage()" alt="Crustopher Avatar" class="crustopher-image" (click)="onAvatarClick()">
		</div>
    </div>
</div>